export default __webpack_public_path__ + "static/media/hht2_ep14_book_wp_01.fca32d58.jpg";